import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import checkIsMobile from 'shared/utils/checkMobileDevice';
import { ASTERISK, OPTIONAL, REQUIRED } from 'shared/components/_constants/label';
import { OptionalTitle } from 'shared/components';

import theme from './Label.scss';

const propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelSuffix: PropTypes.oneOfType([
    PropTypes.oneOf([ASTERISK, OPTIONAL, REQUIRED]),
    PropTypes.node,
    PropTypes.object,
  ]),
  id: PropTypes.string,
  htmlFor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['checkbox']),
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

const defaultProps = {
  label: null,
  labelSuffix: null,
  id: '',
  htmlFor: '',
  size: null,
  type: null,
  className: null,
  isMobile: checkIsMobile(),
};

const Label = ({ isMobile, labelSuffix, size, type, className, label, children, ...rest }) => (
  <label // eslint-disable-line
    className={ classnames(theme.label, className, {
      [theme[size]]: !!size,
      [theme[type]]: !!type,
      [theme.noEvents]: isMobile,
    }) }
    { ...rest }
  >
    <If condition={ label }>
      <Choose>
        <When condition={ typeof label === 'string' }>
          { label }
        </When>
        <When condition={ typeof label === 'object' }>
          <FormattedMessage { ...label } />
        </When>
      </Choose>
    </If>
    { children }
    <If condition={ labelSuffix }>
      <Choose>
        <When condition={ labelSuffix === ASTERISK }>
          <span className={ theme.asterisk }>*</span>
        </When>
        <When condition={ labelSuffix === OPTIONAL }>
          <OptionalTitle />
        </When>
        <When condition={ labelSuffix === REQUIRED }>
          <span className={ theme.required }>&nbsp;<FormattedMessage id="General.Required" /></span>
        </When>
        <When condition={ typeof labelSuffix === 'object' }>
          { labelSuffix }
        </When>
      </Choose>
    </If>
  </label>
);

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
